import { gql } from '@apollo/client';

const BillingProfileDetailsForFetchBillingProfilesForBulkTransferQuery = gql`
  fragment BillingProfileDetailsForFetchBillingProfilesForBulkTransferQuery on InvoiceGroupConnection {
    totalCount
    nodes {
      id
      name
      currency
      transactionAccountId
      isActive
      shipToPriceEligibility
      shipToParty {
        id
        name
        addressLine1
        addressLine2
        city
        country
        state
        phone
        postcode
        taxId
        taxIds {
          id
          label
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      defaultPaymentMethod(refetchDefaultPaymentMethod: false) {
        id
        type
        paymentIssue
        default
        ... on CreditCard {
          card {
            expirationMonth
            expirationYear
            last4Numbers
            brand
          }
        }
        ... on PaymentOnTerms {
          terms {
            invoiceDueDays
            payOnStatement
          }
        }
        ... on PayPal {
          payPal {
            name
            email
          }
        }
      }
      shipToPriceEligibility
      purchaseOrder {
        number
        oneTimeUse
      }
      createdAt
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
`;

export const fetchBillingProfilesForBulkTransferQuery = gql`
  ${BillingProfileDetailsForFetchBillingProfilesForBulkTransferQuery}
  query fetchBillingProfilesForBulkTransfer(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $isFetchBillingProfilesViaCCPEnabled: Boolean = false
  ) {
    transactionAccount(id: $id) {
      id
      billingProfiles(searchOptions: $searchOptions, filterOptions: $filterOptions)
        @skip(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsForFetchBillingProfilesForBulkTransferQuery
      }
      billingProfilesFromCCP(searchOptions: $searchOptions, filterOptions: $filterOptions)
        @include(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsForFetchBillingProfilesForBulkTransferQuery
      }
    }
  }
`;
